real.time = (function($, real) {
    'use strict';

    return {

        init : function(elem) {
            elem.findIncludingSelf('.real-time:not(.real-time-initialized)').each(function() {
                var time, dateOrTimestamp, formatted = null;

                time = $(this);

                time.addClass('real-time-initialized');

                try {
                    dateOrTimestamp = time.attr('datetime');
                    if(isNaN(dateOrTimestamp)) {
                        dateOrTimestamp = new Date(dateOrTimestamp);
                    }
                    const format = time.data('format');
                    switch (format) {
                        case 'locale_date':
                            formatted = real.date(real.locale.getDateFormat(), dateOrTimestamp);
                            break;

                        case 'locale_time':
                            formatted = real.date(real.locale.getTimeFormat(), dateOrTimestamp);
                            break;

                        default:
                            formatted = real.date(time.data('format'), dateOrTimestamp);
                            break;
                    }
                } catch (e) {
                    formatted = null;
                }

                if(formatted !== null) {
                    time.html(formatted);
                }
            });
        },

        initTooltip : function(elem) {
            elem.findIncludingSelf('.real-time-tooltip:not(.real-time-tooltip-initialized)').each(function() {
                var tooltipToggle, helper, dateOrTimestamp, formatted = null;

                tooltipToggle = $(this);

                tooltipToggle.addClass('real-time-tooltip-initialized');

                // Create a helper div element and put the tooltip content as its html.
                helper = $('<div/>');
                helper.html(tooltipToggle.attr('title'));

                // Init all real-time elements within the helper.
                real.time.init(helper);

                // Convert all real-time elements inside the tooltip as plain text.
                helper.findIncludingSelf('.real-time.real-time-initialized').each(function() {
                    let time = $(this);
                    time.replaceWith(time.text());
                });

                // Update the tooltip title attribute.
                tooltipToggle.attr('title', helper.html());

                // Initialize tooltip.
                real.tooltip.init(tooltipToggle);
            });
        },

        destroyTooltip : function(elem) {
            elem.findIncludingSelf('.real-time-tooltip.real-time-tooltip-initialized').each(function () {
                const tooltipToggle = $(this);

                tooltipToggle.removeClass('real-time-tooltip-initialized');

                real.tooltip.destroy(tooltipToggle);
            });
        },

        flatpickrOnOpen : function(selectedDates, dateStr, instance) {
            const container = $(instance.timeContainer);
            let closeBtn = container.find('.flatpickr-close-btn');

            if (closeBtn.length === 0) {
                container.append(''
                    + '<button class="btn btn-primary flatpickr-close-btn">'
                    + '<i class="fa fa-check mr-2" aria-hidden="true"></i>'
                    + 'OK'
                    + '</button>'
                );

                closeBtn = container.find('.flatpickr-close-btn');

                closeBtn.on('click', function(e) {
                    instance.close();
                });

                container.on('keyup', function(e) {
                    if(e.keyCode === 13) {
                        instance.close();
                    }
                });
            }
        },

        getUtcTime : function(time) {
            const [hours, minutes] = time.split(".");

            const browserDate = new Date();
            browserDate.setHours(hours, minutes);

            return browserDate.getUTCHours().toString().padStart(2, '0') + '.' +
                browserDate.getUTCMinutes().toString().padStart(2, '0');
        },

        getBrowserTime : function(time) {
            const [hours, minutes] = time.split(".");

            const browserDate = new Date();
            browserDate.setUTCHours(hours, minutes);

            return browserDate.getHours().toString().padStart(2, '0') + '.' +
                browserDate.getMinutes().toString().padStart(2, '0');
        }

    };

})(jQuery, real);
